import { Link } from "react-router-dom";
import "./ServiceCard.css";

const ServiceCard = ({ service }) => {
  return (
    <Link to={service.route} className="service-card">
      <div className="service-image">
        <img src={service.image} alt={service.title} />

        <span className="service-category">{service.category}</span>
      </div>

      <div className="service-content">
        <h3>{service.title}</h3>

        <p>{service.shortDescription}</p>

        <span className="service-btn">Learn More →</span>
      </div>
    </Link>
  );
};

export default ServiceCard;
